import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import { formatErrorMessage } from '../../util/helpers/registerRejectErrorCodeHelper';
import {
  GET_REQUIRED_DOCUMENTS,
  GET_SOCURE_CAPTURE,
  SOCURE_EVENT,
  SOCURE_UPLOAD_DOCUMENT,
  SOCURE_VERIFICATION,
} from '../actions/documents/documentsActionConstants';
import {
  getRequiredDocumentsError,
  getRequiredDocumentsSuccess,
  getSocureCaptureError,
  getSocureCaptureSuccess,
  socureEventError,
  socureEventSuccess,
  socureUploadDocumentError,
  socureUploadDocumentSuccess,
  socureVerificationError,
  socureVerificationSuccess,
} from '../actions/documents/documentsActions';
import {
  getRequiredDocumentsRequest,
  getSocureCaptureRequest,
  socureDocumentsUploadRequest,
  socureVerificationExecutionRequest,
  socureEventRequest,
} from '../../request/documentsRequests';

function* getRequiredDocuments({ payload }) {
  try {
    const { data } = yield call(getRequiredDocumentsRequest, payload);
    if (data) {
      yield put(getRequiredDocumentsSuccess(data));
    }
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getRequiredDocumentsError(errMsg));
  }
}

function* getSocureCapture({ payload }) {
  try {
    const { data } = yield call(getSocureCaptureRequest, payload);
    if (data) {
      yield put(getSocureCaptureSuccess(data));
    }
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getSocureCaptureError(errMsg));
  }
}

function* socureUploadDocument({ payload }) {
  try {
    yield call(socureDocumentsUploadRequest, payload);
    yield put(socureUploadDocumentSuccess(true));
    if (payload?.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    if (payload?.setErrors) {
      yield call(payload.setErrors, errMsg);
    }
    yield put(socureUploadDocumentError(errMsg));
  }
}

function* socureVerification({ payload }) {
  try {
    const { data } = yield call(socureVerificationExecutionRequest, payload);
    if (data) {
      yield put(socureVerificationSuccess(data));
    }
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(socureVerificationError(errMsg));
  }
}

function* socureEvent({ payload }) {
  try {
    const { data } = yield call(socureEventRequest, payload);
    if (data) {
      yield put(socureEventSuccess(data));
    }
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(socureEventError(errMsg));
  }
}

export default function* documentsSaga() {
  return yield all([
    takeLatest(GET_REQUIRED_DOCUMENTS, getRequiredDocuments),
    takeLatest(GET_SOCURE_CAPTURE, getSocureCapture),
    takeLatest(SOCURE_UPLOAD_DOCUMENT, socureUploadDocument),
    takeLatest(SOCURE_VERIFICATION, socureVerification),
    takeLatest(SOCURE_EVENT, socureEvent),
  ]);
}
